function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Created by pzf on 2019/2/15
 *
 */
import React from 'react';
var index = 0;

var ModalContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ModalContainer, _React$Component);

  function ModalContainer(props) {
    var _this;

    _classCallCheck(this, ModalContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModalContainer).call(this, props));
    _this.state = {
      modalStack: []
    };
    return _this;
  }

  _createClass(ModalContainer, [{
    key: "open",
    value: function open(modal) {
      index += 1;
      modal.index = index;
      this.setState({
        modalStack: [].concat(_toConsumableArray(this.state.modalStack), [modal])
      });
    }
  }, {
    key: "close",
    value: function close(modal) {
      var modalStack = this.state.modalStack;
      var newModalStack = modalStack.filter(function (item) {
        return item !== modal;
      });
      this.setState({
        modalStack: newModalStack
      });
    }
  }, {
    key: "renderModals",
    value: function renderModals() {
      var modalStack = this.state.modalStack;
      var ts = this;
      return modalStack.map(function (modal) {
        return React.createElement(modal.modalClass, {
          key: modal.index,
          modalInstance: {
            close: function close(data) {
              modal.close(data);
              ts.close(modal);
            },
            dismiss: function dismiss(value) {
              modal.dismiss(value);
              ts.close(modal);
            }
          },
          params: modal.params
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", {
        style: {
          display: 'none'
        },
        className: "modal-container"
      }, this.renderModals());
    }
  }]);

  return ModalContainer;
}(React.Component);

export default ModalContainer;
//# sourceMappingURL=ModalContainer.js.map
